import { LoadingEl } from "nate-react-api-helpers";
import { PropsWithChildren } from "react";
import { usePalette } from "./Feed";

// PaletteGate holds back what draws a project until the palette is in hand, so the
// colour lookups can stay synchronous (see projectColors). It goes around a page's
// output rather than the page, so the page's lists are asked for before it opens.
export function PaletteGate(props: PropsWithChildren<{}>) {
    const palette = usePalette();
    if (!palette.ready) return LoadingEl(!palette.error, palette.error, palette.refresh);

    return <>{props.children}</>;
}
